import "./style.css";
import Atom from "../../atom";
import React, { useState } from "react";
import { fileType } from "../@types/file";
import { Trn } from "../../../translations/language";

export default function File(props: fileType) {
  const { id = "file", getValue, multiple } = props;

  const [name, setName] = useState("");
  const [preview, setPreview] = useState<React.ReactNode[]>([]);

  const getFile = (e: React.ChangeEvent) => {
    // @ts-ignore
    const file = e.target.files;
    const names = [];
    const list = [...file];
    const prevPreview = [];
    for (let i in list) {
      prevPreview.push(
        <Atom.Img key={i} className="previewImg me-2" src={URL.createObjectURL(file[i])} />
      );
      if (list[i].name) {
        names.push(list[i].name);
      }
    }
    setPreview(prevPreview);

    setName(names.join(","));
    getValue?.(file);
  };

  const handleChooseFile = () => {
    const elem = document.getElementById(id);
    elem && elem.click();
  };

  return (
    <Atom.Div>
      <Atom.Input
        id={id}
        type="file"
        webkitdirectory
        className="d-none"
        onChange={getFile}
        multiple={multiple}
      />

      <Atom.Div className="input-group mb-1">
        <Atom.Input
          type="text"
          value={name}
          className="form-control px-1"
          onClick={handleChooseFile}
          placeholder={
            multiple
              ? Trn({ text: "you_can_select_multipleFile" })
              : Trn({ text: "select_file" })
          }
        />
        <Atom.Button className="btn btn-primary" onClick={handleChooseFile}>
          {Trn({ text: "select" })}
        </Atom.Button>
      </Atom.Div>

      <Atom.Div className="d-flex">{preview}</Atom.Div>
    </Atom.Div>
  );
}
